import { createFileRoute } from '@tanstack/react-router';

import { PatentBrowse } from '@/module/Author/Patent';

export const Route = createFileRoute('/_auth/author/_author/patent/_patent/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <PatentBrowse />;
}
